<template>
  <div class="buyer-container">
    <div class="buyer-description">
      <h2>Podaci o kupcu</h2>
      <p>Sva polja su obavezna.</p>
    </div>
    <div class="form-container">
      <text-field v-model="buyer.firstName" :validator="vs.buyer.firstName" label="Ime*" />
      <text-field v-model="buyer.lastName" :validator="vs.buyer.lastName" label="Prezime*" />
      <text-field
        v-model.trim="buyer.email"
        :validator="vs.buyer.email"
        type="email"
        label="Email"
        placeholder="Unesi email*"
      />
      <div class="address-container">
        <text-field v-model.trim="buyer.city" :validator="vs.buyer.city" label="Grad*" />
        <text-field
          v-model.number.trim="buyer.postalCode"
          :validator="vs.buyer.postalCode"
          type="number"
          label="Poštanski broj*"
        />
      </div>
      <div class="address-container">
        <text-field
          v-model="buyer.address"
          :validator="vs.buyer.address"
          label="Ulica i kućni broj*"
        />
        <text-field v-model.trim="buyer.country" :validator="vs.buyer.country" label="Država*" />
      </div>
      <text-field
        v-model.trim="buyer.mobile"
        :validator="vs.buyer.mobile"
        label="Unesi broj mobitela*"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'buyer-form',
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    buyer: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style scoped>
.buyer-container {
  display: flex;
  flex-direction: column;
  padding: 32px 24px 40px 24px;
  gap: 2.5rem;
}
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-right: 0;
}
.buyer-description {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.address-container {
  display: flex;
  gap: 1.5rem;
}
h2 {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 28.8px */
  letter-spacing: -0.72px;
}
p {
  color: #333;
  font-family: Rubik;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
}
</style>
